export { default as Thumbnails } from './thumbnails'



// WEBPACK FOOTER //
// ./src/components/images/index.js